export default class WorkList {

    constructor() {

        this.workContainer = document.querySelector('.dynamic-masonry');

        if( this.workContainer === null ) {
            return;
        }

        // Used for loading the first listitems
        this.initialUrl = window.location.pathname.substring(1);

        // Settings - uses HTML data attributes
        this.hasNavigation = this.workContainer.dataset.hasNavigation === 'true'; // Disables category selector and load more button
        this.postsPerPage = this.workContainer.dataset.limit;

        this.masonry = null;
        this.masonryItems = [];
        this.nextPageUrl = null;

        this.footerElement          = document.querySelector('.work-list--footer');
        this.loadMoreEntriesButton  = document.querySelector('a.load-more-entries');
        this.categorySelectorLabel  = document.querySelector('.category-selector span.filtered-category');
        this.categorySelectorLinks  = document.querySelectorAll('.category-selector a');

        this.loadMoreEntriesButtonLoadedClass = 'all-entries-loaded';


        this.init();

    }

    init(){

        this.initMasonry();

        this.loadItems( false, this.initialUrl.split('/').length > 1 ? this.initialUrl : null );

        if ( this.hasNavigation ) {
            this.enableNavigation();
        }
        
    }


    initMasonry() {
        
        this.masonry = new Masonry(this.workContainer, {
            columnWidth: '.grid-sizer',
            itemSelector: '.listitem',
            percentPosition: true,
            transitionDuration: '0.2s'
        });

    }


    enableNavigation() {

        // Will enable load more button
        this.loadMoreEntriesButton.addEventListener('click', event => {
            event.preventDefault();
            this.fetchWork().then(response => {

                this.setFooterState(response.meta);
                this.renderItems(response.data);

            });
        });

        for ( let i = 0; i < this.categorySelectorLinks.length; i++ ) {


            const link = this.categorySelectorLinks[i];

            link.addEventListener('click', event => {

                event.preventDefault();

                const uri = event.target.getAttribute('href');
                window.history.replaceState(null, null, '/'+uri);

                document.querySelector('.category-selector a.active').classList.remove('active');
                
                event.target.classList.add('active');
                this.categorySelectorLabel.innerHTML = event.target.innerHTML;

                let prevTitleArr = document.title.split('|');
                document.title = `${event.target.innerHTML} | ${prevTitleArr[1].trim()}`;

                this.loadItems( true, uri );

            });
        }
    }


    loadItems( removeItemsFirst = false, uri = null ) {

        // Remove all items if not 'Load more' is clicked
        if ( removeItemsFirst ) {
            this.masonryItems.map(item =>{
                this.masonry.remove(item);
            })
            this.masonryItems = [];
            this.masonry.layout();
        }

        // Check for data in sessionStorage
        let sessionData = window.sessionStorage.getItem(window.location.href);
        if ( sessionData == 123 ) { /* Eddie: Something with the session Storage not working*/

            // Load session data
            // TODO - add timestamp for "caching"
            sessionData = JSON.parse(sessionData);
            const sessionMeta = JSON.parse(window.sessionStorage.getItem(`${window.location.href}-meta`));
            
            this.setFooterState(sessionMeta);
            this.renderItems(sessionData);

        } else {

            this.fetchWork( uri ).then(response => {

                this.setFooterState(response.meta);
                this.renderItems(response.data);

            });

        }

    }


    setFooterState( meta ) {

        if ( this.hasNavigation ) {

            this.nextPageUrl = meta.pagination.links.next ? meta.pagination.links.next : null;

            if ( !this.nextPageUrl ) {
                this.footerElement.classList.add(this.loadMoreEntriesButtonLoadedClass);
            } else {
                this.footerElement.classList.remove(this.loadMoreEntriesButtonLoadedClass);
            }

        }

    }


    fetchWork( uri = null ) {

        let url = null;



        if ( uri && uri.split('/').length > 1 ) {
            url = '/api/v1/work/category?uri='+uri+'&limit='+this.postsPerPage;
        } else if ( this.nextPageUrl ) {
            url = this.nextPageUrl;
        } else {
            url = '/api/v1/work?limit='+this.postsPerPage;
        }


        return $.ajax({
            method: 'GET',
            url: url,
        }).done(response => {

            if ( this.nextPageUrl ) {
                // Add items to sessionStorage if load more is pushed
                let sessionData = JSON.parse( window.sessionStorage.getItem(window.location.href) );
                if ( sessionData ) {
                    window.sessionStorage.setItem(window.location.href, JSON.stringify([...sessionData, ...response.data]));
                } else {
                    window.sessionStorage.setItem(window.location.href, JSON.stringify(response.data));
                }
            } else {
                window.sessionStorage.setItem(window.location.href, JSON.stringify(response.data));
            }

            window.sessionStorage.setItem(`${window.location.href}-meta`, JSON.stringify(response.meta));

            return response;

        }).fail(xhr => {
            console.warn(xhr);
            return null;
        });

    }


    renderItems(items) {

        if(items.length === 0) {
            return;
        }

        let output = [];
        let loadedImages = 0;

        let isFinisedLoading = function() {
            if (loadedImages === items.length) {

                output.map(element => {
                    this.workContainer.append(element);
                    this.masonryItems.push(element);
                    this.masonry.appended(element);
                });
                this.masonry.layout();
                setTimeout(Waypoint.refreshAll, 250)

            };
        }.bind(this)


        items.map(item =>{
            
            const element = this.buildItemMarkup(item);
            output.push( element.markup )

            if ( element.image && !element.isVideo ) {

                let loadImage = new imagesLoaded(element.image, res =>{
                    loadedImages++;
                    isFinisedLoading();
                });

            } else if ( element.image && element.isVideo ) {

                // Wait until video is ready before registering
                var interval = setInterval( () => {
                    if(element.image.readyState === 4){
                        
                        loadedImages++;
                        isFinisedLoading();
                        clearInterval(interval);

                    }
                }, 50)

            } else {

                loadedImages++;
                isFinisedLoading();

            }

        });
        
    }

    buildItemMarkup(item){

        const element = document.createElement('div');
        const anchor = document.createElement('a');
        const itemOverlay = document.createElement('div');
        const itemOverlayContent = document.createElement('div');
        const overlayTitle = document.createElement('h2');
        const overlayIngress = document.createElement('p');

        let title = item.previewTitle !== null ? item.previewTitle : item.title;
        let ingress = item.excerpt !== null ? item.excerpt : item.ingress;
        let image = null;
        let isVideo = false;

        element.className = 'listitem work-list-item';
        itemOverlayContent.className = 'overlay-content';

        itemOverlay.className = 'overlay';
        itemOverlay.appendChild(itemOverlayContent);

        overlayTitle.append(document.createTextNode(title));
        itemOverlayContent.appendChild(overlayTitle);

        if( ingress !== null ) {
            overlayIngress.append(document.createTextNode(ingress));
            itemOverlayContent.appendChild(overlayIngress);
        }



        if( item.listVideoUrl !== null && item.listVideoUrl !== '') {

            image = document.createElement('video');
            image.muted = true;
            image.autoplay = true;
            image.loop = true;
            image.playsinline = true
            image.src = item.listVideoUrl;
            isVideo = true;

        } else if ( item.previewImage !== null ) {

            if ( 
                item.previewImage.extension === 'mp4' ||
                item.previewImage.extension === 'ogg' ||
                item.previewImage.extension === 'webm'
            ) {

                image = document.createElement('video');
                image.muted = true;
                image.autoplay = true;
                image.loop = true;
                image.playsinline = true;
                image.src = item.previewImage.src;
                isVideo = true;

            } else {

                image = document.createElement('img');
                image.src = item.previewImage.src;
                image.srcset = item.previewImage.srcset;
                image.alt = item.previewImage.alt;

            }

        } else if(image === null && item.image !== null){

            image = document.createElement('img');
            image.src = item.image.src;
            image.srcset = item.image.srcset;
            image.alt = item.image.alt;

        }

        anchor.append(image);
        anchor.setAttribute('href', item.url);
        anchor.append(itemOverlay);

        element.append(anchor);


        return {
            markup: element,
            image: image,
            isVideo: isVideo,
        }
    }

}
